import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule, Platform } from '@ionic/angular';

import { ModalRegistrationComponent } from './modal-registration.component';

@NgModule({
  imports: [CommonModule, IonicModule, FormsModule, ReactiveFormsModule],
  declarations: [ModalRegistrationComponent],
  providers: [Platform],
})
export class ModalRegistrationModule {}
